export function removePxFromStyle(style: string | null | undefined) {
  if (style === null || style === undefined) return 0;
  return Number(style.replace("px", ""));
}

export function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}
